var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconX = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 28",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "layer1")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bswap",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F00\\u7EA2\\u5305_\\u79FB\\u52A8\\u7AEF_\\u5DF2\\u5F004",
    transform: "translate(-518.000000, -1064.960816)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(350.000000, 1039.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(168.000000, 25.960816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0729988253,0 L11.6556469,15.4436017 L0,28 L2.62342675,28 L12.8281591,17.0064368 L21.0729988,28 L30,28 L17.7653969,11.6878776 L28.6145326,0 L25.9911059,0 L16.5933882,10.1245405 L9,0 L0.0729988253,0 Z M3.93086088,1.92681046 L8.03188454,1.92681046 L26.1416345,26.0731895 L22.0406108,26.0731895 L3.93086088,1.92681046 Z",
    id: "path1009"
  })))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconX, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_x.43dbb84d.svg";
export { ForwardRef as ReactComponent };